import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const HtmlDescription = ({
  content,
  size = 'base',
  className,
  color = 'gray',
}: {
  content: string;
  className?: string;
  size?: 'sm' | 'base' | 'large';
  color?: 'white' | 'gray' | 'foreground';
}) => {
  return (
    <HtmlRendererRaw
      className={cn(
        'ea-html-description',
        className,
        size === 'sm' && 'ea-html-description--sm',
        size === 'base' && 'ea-html-description--base',
        size === 'large' && 'ea-html-description--large',
        color === 'white' && 'text-white',
        color === 'foreground' && 'text-foreground',
        color === 'gray' && 'text-[#999999]',
      )}
      html={content}
    />
  );
};
